import { isEmpty } from 'lodash';

const checkFormUpsertValidation = ({ formField, errorFields, isShowAllFields }) => {
  let isValid = false;

  if (isShowAllFields) {
    isValid =
      !isEmpty(formField?.accountId) &&
      !isEmpty(formField?.studio) &&
      !isEmpty(formField?.selectedHost) &&
      !isEmpty(formField?.normalLiveHours) &&
      !isEmpty(formField?.paydayLiveHours) &&
      !isEmpty(formField?.normalStart) &&
      !isEmpty(formField?.normalEnd) &&
      !isEmpty(formField?.paydayStart) &&
      !isEmpty(formField?.paydayEnd) &&
      isEmpty(errorFields);

    if (formField?.type?.value === 'Cross-Platform') {
      isValid = isValid && !isEmpty(formField?.accountId2) && !isEmpty(formField?.studio2);
    }

    if (formField?.isUseAgency === true) {
      isValid = isValid && !isEmpty(formField?.agencyNormalStart) && !isEmpty(formField?.agencyNormalEnd);
      if (formField?.paydayLiveHours?.value !== '24') {
        isValid = isValid && !isEmpty(formField?.agencyPaydayStart) && !isEmpty(formField?.agencyPaydayEnd);
      }
    }
  }

  return isValid;
};

export default checkFormUpsertValidation;
